module.exports = __webpack_public_path__ + "static/media/forest.2687247b.svg";